import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import NodeWrapper from "./NodeWrapper";
import { AccessTime } from "@mui/icons-material";

/**
 * Date & Time Node — Manipular datas (formatar, adicionar, subtrair).
 *
 * data.operation: "format" | "add" | "subtract" | "diff" | "now"
 * data.sourceVar: string — variavel de entrada (ex: "dataVencimento")
 * data.outputVar: string — variavel de saida
 * data.format: string — formato de saida (ex: "DD/MM/YYYY HH:mm")
 * data.amount: number — quantidade para add/subtract
 * data.unit: "minutes" | "hours" | "days" | "months" | "years"
 */
const DateTimeNode = memo(({ id, data, isConnectable, selected }) => {
  const operation = data?.operation || "format";
  const format = data?.format || "DD/MM/YYYY";
  const outputVar = data?.outputVar || "";

  const opLabels = {
    format: "Formatar",
    add: "Adicionar",
    subtract: "Subtrair",
    diff: "Diferenca",
    now: "Agora",
  };

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<AccessTime />}
      title="Data/Hora"
      color="#00897B"
      bgColor="#E0F2F1"
      isConnectable={isConnectable}
      selected={selected}
      minWidth={200}
    >
      <div style={{
        background: "#fff", border: "1px solid #e0e0e0",
        borderRadius: 6, padding: "5px 10px", fontSize: 11,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#00897B", borderRadius: 4, padding: "1px 8px",
          }}>{opLabels[operation] || operation}</span>
          <span style={{ color: "#666", fontFamily: "'Fira Code', monospace" }}>{format}</span>
        </div>
        {outputVar && (
          <div style={{ marginTop: 4, color: "#999", fontSize: 10 }}>
            → ${"{" + outputVar + "}"}
          </div>
        )}
      </div>
    </NodeWrapper>
  );
});

DateTimeNode.displayName = "DateTimeNode";
export default DateTimeNode;
